import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useOperators } from '../hooks';
import { Box, IconButton, Typography } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import { StyledFlex } from '../../components/StyledFlex';
import OperatorForm from './Form';
import { useTranslation } from 'react-i18next';

export default function Operator() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation(undefined, {
    keyPrefix: 'cbam.operators',
  });
  const { data } = useOperators();
  const operatorId = Number(id);
  const operator = data.find((operator) => operator.id === operatorId);
  return (
    <Box>
      <StyledFlex sx={{ justifyContent: 'flex-start' }}>
        <IconButton onClick={() => navigate('..')}>
          <ChevronLeft />
        </IconButton>
        <Typography variant="h2">
          {t('operator')}: {operator?.name || t('new')}
        </Typography>
      </StyledFlex>
      <br />
      <OperatorForm
        key={data.length}
        id={operatorId}
        onSaved={() => navigate('..')}
      />
    </Box>
  );
}
